export default "__VITE_ASSET__DEWr5A_5__"